import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import useProductCardContext from 'data-hooks/useProductCardContext';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import avo from 'analytics/avo';
const useProductWishlistEvent = () => {
  const $ = _c(10);
  const product = useProductCardContext();
  const currentPage = useUserCurrentPageType();
  let t0;
  if ($[0] !== currentPage || $[1] !== product) {
    t0 = () => {
      if (product?.id) {
        avo.productAddedToWishlist({
          productId: product.id,
          fabricId: 0,
          fabricName: "",
          price: product.price ? parseFloat(product.price) : 0,
          productFamily: product.productFamily || "",
          sku: product.sku,
          fabricColor: "",
          fullPrice: product.originalPrice ? parseFloat(product.originalPrice) : 0,
          isClearance: !!product.isClearance,
          quickship: !!product.quickship,
          location: currentPage,
          name: product.name,
          variant: product.label,
          category: product.productType,
          currency: "USD"
        });
      }
    };
    $[0] = currentPage;
    $[1] = product;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const productAddedToWishlistEvent = t0;
  let t1;
  if ($[3] !== product) {
    t1 = () => {
      if (product?.id) {
        avo.productRemovedFromWishlist({
          productId: product.id,
          category: product.productType,
          isClearance: !!product.isClearance,
          name: product.name,
          price: product.price ? parseFloat(product.price) : 0,
          quantity: 1,
          sku: product.sku,
          variant: product.label,
          fullPrice: product.originalPrice ? parseFloat(product.originalPrice) : 0,
          productFamily: product.productFamily || "",
          contentIds: [product.sku.split("-")[0]] || [],
          isFlashSale: product.variantsToShow[0]?.isFlashSale || false,
          currency: "USD"
        });
      }
    };
    $[3] = product;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const productRemovedFromWishlistEvent = t1;
  let t2;
  if ($[5] !== productAddedToWishlistEvent || $[6] !== productRemovedFromWishlistEvent) {
    t2 = isFavorited => {
      if (!isFavorited) {
        productAddedToWishlistEvent();
      } else {
        productRemovedFromWishlistEvent();
      }
    };
    $[5] = productAddedToWishlistEvent;
    $[6] = productRemovedFromWishlistEvent;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const productWishlistEvent = t2;
  let t3;
  if ($[8] !== productWishlistEvent) {
    t3 = {
      productWishlistEvent
    };
    $[8] = productWishlistEvent;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default useProductWishlistEvent;